import { createSelector } from '@reduxjs/toolkit';
import { State } from '../../../store/state';

export const containerSelector = (state: State) => state.container.container;
export const totalSelector = (state: State) => state.container.total;
export const noMoreSelector = (state: State) => state.container.noMore;
export const optionsSelector = (state: State) => state.container.options;
export const containerCodeSelector = (state: State) => state.container.containerCode;
export const filterFieldSelector = (state: State) => state.container.filterField;
export const pageSelector = (state: State) => state.container.page;
export const errorCodeSelector = (state: State) => state.container.errorCode;

const containersIdsSelector = (state: State) => state.container.containers.ids;
const containersEntitiesSelector = (state: State) =>
  state.container.containers.entities;

export const containersSelector = createSelector(
  [containersIdsSelector, containersEntitiesSelector],
  (ids, entities) => ids.map((id) => entities[id])
);

const containerProductsIdsSelector = (state: State) => state.container.products.ids;
const containerProductsEntitiesSelector = (state: State) =>
  state.container.products.entities;

export const containerProductsSelector = createSelector(
  [containerProductsIdsSelector, containerProductsEntitiesSelector],
  (ids, entities) => ids.map((id) => entities[id])
);